import React, { useEffect, useState } from "react";
import './Catalogos.scss';
import OptionsGroup from "../../../components/moleculesv2/OptionsGroup/OptionsGroup";
import CrudPaquetes from "./Partes/CrudPaquetes/CrudPaquetes";
import { getConceptos, getPaquetes, getServicios, getTipoUnidad } from "./integracionPaquetes";
import CrudConceptos from "./Partes/CrudConceptos/CrudConceptos";
import CrudServicios from "./Partes/CrudServicios/CrudServicios";


const Catalogos = () => {
    const [activeOption, setActiveOption] = useState("Paquetes");
    const [data, setData] = useState({
        paquetes: [],
        servicios: [],
        conceptos: [],
        tipoUnidades:[]
    })
    useEffect(() => {
        getData()
    }, [])
    
    
    const getData = async () => {
        await getConceptos()
            .then((res) => {
                setData(prev=>({...prev,conceptos:res}))
            })
            .catch((error) => {
                console.log("error",error);
                
            })
        await getServicios()
            .then((res) => {
                setData(prev=>({...prev,servicios:res}))
            })
            .catch((error) => {
                console.log("error",error);
                
            })
        await getPaquetes()
            .then((res) => {
                setData(prev=>({...prev,paquetes:res}))
            })
            .catch((error) => {
                console.log("error",error);
                
            })
        await getTipoUnidad()
            .then((res) => {
                setData(prev=>({...prev,tipoUnidades:res}))
            })
            .catch((error) => {
                console.log("error",error);
                
            })
    }
    console.log("data",data);
    
    return (
        <div className="Catalogos">
            <div className="Pestañas">
                <OptionsGroup
                    activeValue={activeOption}
                    onSelect={setActiveOption}
                    className="options-group-position"
                    options={[
                        { label: "Paquetes", value: 'Paquetes' },
                        { label: "Servicios", value: "Servicios" },
                        { label: "Conceptos", value: "Conceptos" }
                    ]} />
            </div>
            <div className="CatalogosCruds" >
                {
                    activeOption === "Paquetes" &&
                    <CrudPaquetes data={data}></CrudPaquetes>
                }
                {
                    activeOption === "Servicios" &&
                   <CrudServicios data={data} setData={setData}></CrudServicios>
                }
                {
                    activeOption === "Conceptos" &&
                    <CrudConceptos setData={setData} data={data}></CrudConceptos>
                }
            </div>
        </div>

    )
}
export default Catalogos;